var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"charts"},[_c('StatEnterExitFilter',{staticClass:"chart"})],1),_c('div',{staticClass:"charts nopadding"},[_c('TableEnterExit',{staticClass:"chart"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }